import React from 'react';
import classnames from 'classnames';

import Col from './col';

import classes from '../table.module.css';

export default function Body({ data, names, rowsCount, hideRows, onCellClick }) {
  return (
    <tbody>
      {data.map((row, rowIdx) => (
        <tr
          data-testid="table-row"
          key={`tbody-${rowIdx}`}
          className={classnames(classes.bodyRow, 'table-body-row', {
            'd-none': rowIdx >= rowsCount && hideRows,
          })}
        >
          {names.map((name, nameIdx) => (
            <Col
              key={`tbody-${rowIdx}-col-${nameIdx}`}
              data={row[name]}
              onClick={onCellClick(rowIdx, nameIdx)}
            />
          ))}
        </tr>
      ))}
    </tbody>
  );
}
